'use client';

import type { HeaderImage, HeaderLabels, HeaderLink, NavCategory } from './header-types';

import { CategoryMegaMenu } from './category-mega-menu';
import { HeaderDrawer } from './header-drawer';

type HeaderNavigationProps = {
  categories: NavCategory[];
  links: HeaderLink[];
  logo: HeaderImage | null;
  labels: HeaderLabels;
};

/** One client boundary for both menus, so the category tree is serialised once per page. */
export function HeaderNavigation({ categories, links, logo, labels }: HeaderNavigationProps) {
  return (
    <>
      <CategoryMegaMenu categories={categories} labels={labels} />
      <HeaderDrawer categories={categories} links={links} logo={logo} labels={labels} />
    </>
  );
}
